import { Box, Stack, styled, Typography } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const CustomCalendarHeaderRoot = styled(Stack)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: `1px solid ${theme.palette.stroke.strokeDefault2}`,
  padding: `${pxToRem(16)} ${pxToRem(24)}`,
}));

export const TextWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  gap: theme.functions.pxToRem(12),
  userSelect: "none",
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fw_semibold_500,
  textTransform: "capitalize",
}));
export const ActionBtn = styled(Box)<{
  isActive?: boolean;
  disabled?: boolean;
}>(({ theme, isActive, disabled }) => ({
  width: 24,
  height: 24,
  borderRadius: theme.functions.pxToRem(4),
  background: theme.palette.background.bgPrimary,
  cursor: "pointer",
  "&:hover": {
    background: disabled
      ? "transparent"
      : theme.palette.background.bgBrandPrimary,
    svg: {
      path: {
        fill: disabled
          ? theme.palette.icon.icDisable
          : theme.palette.background.bgBrand,
      },
    },
  },
  svg: {
    path: {
      fill: disabled
        ? theme.palette.icon.icDisable
        : theme.palette.icon.icDefault,
    },
  },

  ".icon-down": {
    transform: isActive && "rotate(0.5turn)",
    transition: "all 0.5s ease-out",
  },
}));

export const Time = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.textPrimary,
  fontSize: theme.typography.size.xx_13,
  lineHeight: theme.typography.lineHeight.md,
}));

export const TimeInOutLable = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.textSecondary,
  fontSize: theme.typography.size.xs_12,
}));
